import jQuery from 'jquery'
import carouselTemplate from './assets/templates/carousel.mst'
import './assets/styles/carousel.scss'
import modalController from '../modal'
/**
 * This action execute the carrousel action. The carrpusel show the source slides
 * given and scroll it with the arrows.
 * TODO:
 * Render the selected slides in modal
 * @param {Object} event - The carrousel JQuery event.
 * @param {Object} widget - The Chatwidget carrousel JQuery object.
 * @param {Object} params.description - The above description message for carrousel sliders.
 * @param {string} params.slides[].title - The title of the image
 * @param {string} params.slides[].source - The image source url
 */
function action (event, widget, params) {
  // Create the html carousel template
  let carouselElement = jQuery(jQuery.mustache(carouselTemplate, {
    sliders: params.slides,
    description: params.description,
    sender: 'assistant'
  }))
  // Create the modal template
  let modal = modalController.create()
  // Scroll the widget when the image was loaded
  carouselElement.find('img').on('load', function () {
    widget._log(carouselElement)
  })
  // Select the carousel element for arrow and slider controls
  let prevArrow = carouselElement.find('.prev')
  let nextArrow = carouselElement.find('.next')
  // Keep the current position for arrow state
  let curPos = 0
  // Start the carousel with the previous arrow hidden
  prevArrow[0].style.display = 'none'
  // scroll the slider on next arrow click event
  nextArrow.click(function (event) {
    const slider = jQuery(event.currentTarget).prev()
    const slideWidth = slider.outerWidth()
    curPos += slideWidth
    slider.animate({
      scrollLeft: curPos
    }, 500, function () {
      // Set the next arrow state
      if (curPos >= (params.slides.length - 1) * slideWidth) {
        nextArrow[0].style.display = 'none'
      }
      if (curPos > 0) {
        prevArrow[0].style.display = 'block'
      }
    })
  })
  // The same behavior for previous arrow
  prevArrow.click(function (event) {
    const slider = jQuery(event.currentTarget).next()
    const slideWidth = slider.outerWidth()
    curPos -= slideWidth
    slider.animate({
      scrollLeft: curPos
    }, 500, function () {
      if (curPos <= 1e-2) {
        prevArrow[0].style.display = 'none'
      }
      if (curPos < (params.slides.length - 1) * slideWidth) {
        nextArrow[0].style.display = 'block'
      }
    })
  })
  // Show the target inside the modal with on click image event
  carouselElement.find('.wgt-action-image-content-img').on('click', function (event) {
    modalController.replaceContent({
      content: jQuery(event.currentTarget).prop('outerHTML'),
      title: params.description
    })
    modal.show()
  })
}

export default action
